<!-- VapiEmbed.vue -->
<template>
  <div>
    <h5>Permissão para uso do Microfone</h5>
    <p>Para prosseguir, precisamos da sua permissão para acessar o microfone do seu dispositivo. Isso é necessário para que você possa interagir por voz durante o bate-papo.</p>
    <div
      v-if="micPermission === 'denied'"
      class="alert my-3"
      :class="`alert-danger`">
      Acesso ao microfone negado pelo usuário.
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntervoiceMicPermission',
  components: {
  },
  props: {
  },
  data () {
    return {
      message: {},
      micPermission: null
    }
  },
  computed: {
  },
  async mounted () {
    if (await this.hasPhysicalMic()) {
      const micPermissionState = await this.getMicPermissionState()
      if (micPermissionState !== 'granted') {
        const stream = await this.requestMicAccess()
        if (!stream) {
          this.micPermission = 'denied'
          return
        }
      }
      this.$emit('mic-permission-granted')
    }
  },
  watch: {
  },
  methods: {
    async hasPhysicalMic () {
      const devices = await navigator.mediaDevices.enumerateDevices()
      return devices.some(d => d.kind === 'audioinput')
    },
    async getMicPermissionState () {
      if (!navigator.permissions || !navigator.permissions.query) return 'unknown'
      try {
        const { state } = await navigator.permissions.query({ name: 'microphone' })
        return state // 'granted' | 'denied' | 'prompt'
      } catch {
        return 'unknown'
      }
    },
    async requestMicAccess () {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: {
          echoCancellation: true, noiseSuppression: true, autoGainControl: true
        } })
        return stream
      } catch (err) {
        console.error('getUserMedia erro:', err)
        return null
      }
    }
  }
}
</script>

<style>
</style>
